module.exports = __webpack_public_path__ + "static/media/link-resolutions.922151d9.png";